import type { ReactNode } from 'react';

import { Card } from '@/components/ui/card';

/** Layout helpers for the gallery. Not part of the widget catalogue. */

export const GallerySection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <section>
    <h2 className="mb-3 text-section-title font-semibold text-fg">{title}</h2>
    <Card className="space-y-6 p-5">{children}</Card>
  </section>
);

export const StateRow = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="space-y-2">
    <p className="text-overline font-semibold tracking-wide text-fg-tertiary uppercase">
      {label}
    </p>
    <div className="flex flex-wrap items-center gap-3">{children}</div>
  </div>
);
